export default "__VITE_ASSET__DNAHcDI3__"